import {useCallback,useRef,useState} from 'react'
import type {Area} from '@briary/shared'
import {useAuth} from '../../lib/auth'
import {useRouter} from '../../lib/router'
import {useSystem} from '../../lib/mode'
import {HelpDialog} from './HelpDialog'
import './help.css'

export function HelpButton({area}:{area:Area}){
  const {me}=useAuth(),{loc}=useRouter(),system=useSystem()
  const [open,setOpen]=useState(false),trigger=useRef<HTMLButtonElement>(null)
  const close=useCallback(()=>setOpen(false),[])
  if(!me||(area!=='admin'&&area!=='portal')||!me.areas.includes(area))return null
  return <>
    <button ref={trigger} type="button" className="context-help-trigger" aria-label="Help with this page" aria-haspopup="dialog" aria-expanded={open} title="Help with this page" onClick={()=>setOpen(true)}><span aria-hidden="true">?</span></button>
    {open&&<HelpDialog me={me} area={area} location={loc} environment={{mode:system.data?.mode}} onClose={close} returnFocus={trigger}/>}
  </>
}
